/*
 * Initial AU – product page helpers.
 * 1. The page opens on a size that can be bought (rendered by product-summary.liquid). If a link asked
 *    for a size that is sold out, that size stays selected, shows "Sold out", and a short note points
 *    to the sizes in stock – nothing is swapped silently.
 * 2. Blocks double clicks on Add to Cart while a request is running.
 * 3. Keeps the stock line and the condition label in sync with the selected size.
 * Works alongside the theme's own variant script (theme.js) rather than replacing it.
 */
(function () {
  'use strict';

  var requestedId = (window.location.search.match(/[?&]variant=(\d+)/) || [])[1] || null;

  function strings() {
    var s = (window.iauStrings || {});
    return {
      unavailable: s.size_unavailable || 'That size is sold out. Choose one of the sizes in stock.'
    };
  }

  function initForm(form) {
    if (form.dataset.iauReady) return;
    form.dataset.iauReady = '1';
    var summary = form.closest('.product-summary');
    var button = form.querySelector('[name="add"]');

    // A link asked for a size that is sold out: say so next to the size buttons.
    var dataEl = summary && summary.querySelector('[data-product-variants]');
    if (requestedId && dataEl) {
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { variants = []; }
      var asked = variants.filter(function (v) { return String(v.id) === requestedId; })[0];
      var anyAvailable = variants.some(function (v) { return v.available; });
      var picker = summary.querySelector('.product-variants');
      if (asked && !asked.available && anyAvailable && picker && !picker.querySelector('.iau-size-note')) {
        var note = document.createElement('p');
        note.className = 'iau-size-note';
        note.setAttribute('role', 'status');
        note.textContent = strings().unavailable;
        picker.appendChild(note);
        picker.addEventListener('change', function () { note.remove(); }, { once: true });
      }
    }

    // Capture phase: runs before the theme's add-to-cart click handler.
    if (button) {
      document.addEventListener('click', function (e) {
        var target = e.target.closest('[name="add"]');
        if (target !== button) return;
        if (button.classList.contains('loading')) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      }, true);
    }
  }

  /* ---------- Stock for the selected size ---------- */
  var stockWidgets = [];

  function plural(strings, base, n) {
    var tpl = n === 1 ? strings[base + '_one'] : strings[base + '_other'];
    return (tpl || '').replace('99999', String(n));
  }

  function renderStock(w, id) {
    var line = w.el.querySelector('[data-iau-stock-text]');
    var alert = w.el.querySelector('[data-iau-stock-alert]');
    var alertText = w.el.querySelector('[data-iau-stock-alert-text]');
    var s = w.data.strings;
    var state, text;
    var v = id ? w.data.variants[String(id)] : null;

    if (id === null) {
      state = w.productAvailable ? 'choose' : 'soldout';
      text = w.productAvailable ? s.choose : s.sold_out;
    } else if (!v || !v.a) {
      state = 'soldout'; text = s.sold_out;
    } else if (v.t && typeof v.q === 'number' && v.q > 0) {
      text = plural(s, 'available', v.q);
      state = (!v.c && w.threshold > 0 && v.q <= w.threshold) ? 'low' : 'count';
    } else if (v.t && v.c) {
      state = 'backorder'; text = s.backorder;
    } else {
      state = 'in'; text = s.in_stock;   // not tracked: never invent a number
    }

    w.el.setAttribute('data-state', state);
    if (line) line.textContent = text;
    if (alert) {
      if (state === 'low') {
        alertText.textContent = plural(s, 'low', v.q);
        alert.hidden = false;
      } else {
        alert.hidden = true;
        alertText.textContent = '';
      }
    }
  }

  function initStock() {
    document.querySelectorAll('[data-iau-stock]').forEach(function (el) {
      var dataEl = el.querySelector('[data-iau-stock-data]');
      if (!dataEl) return;
      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }
      var anyAvailable = Object.keys(data.variants).some(function (k) { return data.variants[k].a; });
      stockWidgets.push({ el: el, data: data, threshold: parseInt(el.getAttribute('data-threshold'), 10) || 0, productAvailable: anyAvailable });
    });
    if (!stockWidgets.length) return;

    document.addEventListener('product-variant-updated', function (e) {
      var v = e.detail && e.detail.selected;
      stockWidgets.forEach(function (w) {
        if (v && !w.data.variants[String(v.id)]) return;   // a different product on the page
        renderStock(w, v ? v.id : undefined);
      });
    });
  }

  window.iauStockReset = function () {
    stockWidgets.forEach(function (w) { renderStock(w, null); });
  };

  function initCondition() {
    var box = document.querySelector('[data-iau-condition]');
    if (!box) return;
    var dataEl = box.querySelector('[data-iau-variant-conditions]');
    if (!dataEl) return;
    var map = {};
    try { map = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var valueEl = box.querySelector('[data-iau-condition-value]');
    var fallback = box.getAttribute('data-default') || '';

    document.addEventListener('product-variant-updated', function (e) {
      var v = e.detail && e.detail.selected;
      if (!v || !valueEl) return;
      var text = map[v.id] || fallback;
      valueEl.textContent = text;
      box.hidden = !text;
    });
  }

  function init() {
    initStock();
    document.querySelectorAll('[data-type="add-to-cart-form"]').forEach(initForm);
    initCondition();
  }

  // Run after theme.js has finished its own DOMContentLoaded setup.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 0); });
  } else {
    setTimeout(init, 0);
  }
})();
